import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {
	LEAD_STATUS_CONFIG_EDITED,
	LEAD_STATUS_CONFIG_FETCHED,
	LEAD_STATUS_EDITED,
	LEAD_STATUS_SORT_ORDER_UPDATED,
	LEAD_STATUSES_FETCHED
} from "../../action/leadStatus/actionType";
import {LeadStatusState} from "./LeadStatusState";

const initState: LeadStatusState = {
	leadStatuses: none,
	leadStatusConfig: none
};

const reducer = handleActions({
	[LEAD_STATUSES_FETCHED]: (state: LeadStatusState, action: Action<any>): LeadStatusState => {
		return {...state, leadStatuses: option(action.payload.leadStatuses)}
	},
	[LEAD_STATUS_SORT_ORDER_UPDATED]: (state: LeadStatusState,
		action: Action<LEAD_STATUS_SORT_ORDER_UPDATED>): LeadStatusState => {
		return {...state, leadStatuses: option(action.payload.leadStatuses)};
	},
	[LEAD_STATUS_EDITED]: (state: LeadStatusState, action: Action<LEAD_STATUS_EDITED>): LeadStatusState => {
		const leadStatuses = state.leadStatuses.getOrElse([]).map(
			s => s.id === action.payload.leadStatus.id ? action.payload.leadStatus : s);
		return {...state, leadStatuses: option(leadStatuses)}
	},
	[LEAD_STATUS_CONFIG_FETCHED]: (state: LeadStatusState, action: Action<LEAD_STATUS_CONFIG_FETCHED>): LeadStatusState => {
		return {...state, leadStatusConfig: option(action.payload.leadStatusConfig)}
	},
	[LEAD_STATUS_CONFIG_EDITED]: (state: LeadStatusState, action: Action<LEAD_STATUS_CONFIG_EDITED>): LeadStatusState => {
		const leadStatusConfig = state.leadStatusConfig.getOrElse([]).map(
			lsc => lsc.settingsName === action.payload.leadStatusConfig.settingsName ? action.payload.leadStatusConfig : lsc);
		return {...state, leadStatusConfig: option(leadStatusConfig)}
	}
}, initState);

export default reducer;
